export default "/assets/webshop/img/native-spirit.jpg?22d2ba88ca4fdce64388fbeafa804794";